import script from "./LandingLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingLayout.vue?vue&type=script&lang=ts&setup=true"

import "./LandingLayout.vue?vue&type=style&index=0&id=3694a18b&lang=css"

const __exports__ = script;

export default __exports__